export const css = {
    scoreChart: '_30iszrC3',
    title: '_2TwdDeP9',
    scoreContainer: '_1ezMc9yP',
    small: '_1ZdRdrHM',
    bestScore: '_3YeViNqH',
    noScore: '_2lYivwjn',
    lowScore: '_2c6Hbmb3',
    midScore: '_3vBYSM2q',
    highScore: '_1hdL5xQv',
    ' _key': 'progress-chart/score-chart'
};
export default css;
